exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".erro404{width:100%}.button{background-color:#ff0004;border:none;color:#fff;padding:15px 32px;text-align:center;text-decoration:none;display:inline-block;font-size:16px;margin:4px 2px;cursor:pointer;border-radius:50px}.button.btn-secondary:hover{color:#fff}.button.btn-secondary:hover,.button.btn-secondary:not(:disabled):not(.disabled).active{background-color:#ff0004;border-color:#ff0004}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ebd93be","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Erro404.vue
// module id = hlf8
// module chunks = 0